<template>
  <div class="bar" :class="{ 
                  'white-bar-dark' : isDark,
                  'white-bar-light' : !isDark,
                  'bar-border-dark' : isDark,
                  'bar-border-light' : !isDark
                }"
                :style="styleWhiteObject">
    <span v-if="white != 0" class="white-text bar-text" >{{ white }}%</span>
  </div>
  <div  v-if="draw != 0" class="bar draw-bar" v-bind:class="borderColorClass"  :style="styleDrawObject">
    <span class="white-text bar-text"></span>
  </div>
  <div v-if="black != 0" class="bar black-bar" v-bind:class="borderColorClass"  :style="styleBlackObject">
    <span class="black-text bar-text">{{ black }}%</span>
  </div>
</template>

<script setup>

  import { ref } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';

  const props = defineProps({
    white: String,
    draw: String,
    black: String
  })

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
  const borderColorClass = ref(isDark.value ? "bar-border-dark" : "bar-border-light")
  const whiteColorClass = ref(isDark.value ? "white-bar-dark" : "white-bar-light")

  const ratio = .96
  const whiteNumber = ref(parseInt(props.white * ratio))
  const drawNumber = ref(parseInt(props.draw * ratio))
  const blackNumber = ref(parseInt(props.black * ratio) )

  const redrawFlag = ref(true)

  //console.log("winloss props",props)
  //console.log("winloss numbers",whiteNumber.value,drawNumber.value,blackNumber.value)

  const styleWhiteObject = ref({})
  const styleDrawObject = ref({})
  const styleBlackObject = ref({})

  calcWidths()

  function calcWidths() {
    styleWhiteObject.value = { width : whiteNumber.value + '%' , overflow:'hidden'}
    styleDrawObject.value = { width : drawNumber.value + '%' , overflow:'hidden'}
    styleBlackObject.value = { width : blackNumber.value + '%' , overflow:'hidden'}
  }
 
</script>

<style scoped>

.bar {
  display: inline-block;
  height: 20px;
  margin-top: 5px;
  margin-bottom : 5px;
  
}

.bar-border-light {
  border: 1px solid black;
}
.bar-border-dark {
  border: 1px solid white;
}

.white-bar-light {
  background-color: #fff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-left : 1%;
}

.white-bar-dark {
  background-color: #f7f7f7;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-left : 1%;
}

.draw-bar {
  background-color: gray;
}
.black-bar {
  background-color: #000;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  margin-right : 1%;
}
.bar-text {
  display: inline-block;
  width: 100%;
  font-size : 14px;
  text-align: center;
  bottom: 3px;
  position: relative;
}
.white-text {
  color : #000;
}

.black-text {
  color : #fff;
}

</style>